import React, { useEffect, useState } from 'react';
import './FormName.css';

const FormNames = ({ forms, activeForm, completedForms }) => {
  const [stepFormNames, setStepFormNames] = useState([]);

  useEffect(() => {
    console.log('Completed Forms:', completedForms);
    console.log('Active Form:', activeForm);

    const mergedFormNames = [...new Set([...completedForms, activeForm])];  
    setStepFormNames(mergedFormNames);
  }, [completedForms, activeForm]);

  const renderFormNames = () => {
    return stepFormNames.map((formName, index) => {
      const isActive = formName === activeForm;
      const isCompleted = completedForms.includes(formName);
      return (
        <div
          key={index}
          className={`rightforms ${isCompleted ? 'filled-form' : ''} ${isActive ? 'active-form' : ''}`}
        >
          {formName}
          {isCompleted && !isActive && <i className="fas fa-check tick-mark"></i>}
        </div>
      );
    });
  };

  return (
    <div className="form-names-container">
      {renderFormNames()}
    </div>
  );
};

export default FormNames;
